import { Component, OnInit } from '@angular/core';
import { ItemsListContainerBase } from '@fi-app/components/items-list-container-base';
import { ChecklistTemplateListData, ChecklistTemplateListDataService } from '../checklist-template-list-data.service';
import { AccessToApplicationTypeService } from '@fi-shared/fi-shared-services/access-to-application-type.service';
import { ChecklistService } from '@fi-app/checklist/checklist.service';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { SideListOptionType } from '@fi-shared/types/side-list-option-type';
import { ApplicationSettingsType } from '@fi-shared/types/application-settings-type';
import { AccessRightType } from '@fi-shared/types/access-right-type';
import { ILightWeightObjectCollection } from '@fi-shared/models';
import { AppTextService } from '@fi-shared/app-text';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { TabsModuleService } from '@fi-app/utilities/tabs/tabs-module.service';
import { IItemsListParameterBase, ISideListOptionsItem } from '@fi-shared/fi-items-list/fi-items-list';
import { FiLocalSearchGroupType } from '@fi-shared/fi-local-search2/fi-local-search-group-type';

@Component({
    selector: 'fi-checklist-template-list-view',
    templateUrl: './checklist-template-list-view.component.html',
    styleUrls: ['./checklist-template-list-view.component.scss'],
    standalone: false,
})
export class ChecklistTemplateListViewComponent
    extends ItemsListContainerBase<ChecklistTemplateListData>
    implements OnInit
{
    sideListOptionsTopChecklist: ISideListOptionsItem[] = [];
    FiStateNames = FiStateNames;

    constructor(
        private checklistTemplateListDataService: ChecklistTemplateListDataService,
        private accessToApplicationTypeService: AccessToApplicationTypeService,
        private checklistService: ChecklistService,
        private appTextService: AppTextService,
        private tabsModuleService: TabsModuleService,
    ) {
        super();
    }

    ngOnInit() {
        super.onInit(
            () => {
                return this.checklistTemplateListDataService.getInstance();
            },
            { showDelete: true },
        );

        this.tabsModuleService.setTabsSettings({
            listData: this.ListData,
        });

        this.initSideList();
    }

    private initSideList() {
        if (
            this.accessToApplicationTypeService.HasAccessToApplicationType(
                ApplicationSettingsType.ChecklistLocal,
                AccessRightType.Admin,
            )
        ) {
            this.sideListOptionsTopChecklist = [
                { value: SideListOptionType.SharedWithMe, text: this.appTextService.get('all_templates') },
                { value: SideListOptionType.CreatedBy, text: this.appTextService.get('my_templates') },
            ];
        } else {
            this.ListData.FilterType = SideListOptionType.SharedWithMe;
        }
        if (this.ListData.Statefull) {
            this.ListData.setFromStateFilterType(this.sideListOptionsTopChecklist);
        }
    }

    protected LoadItems(): Promise<void> {
        const fetchingAllData = this.ListData.fetchingAllData;
        const parameter = this.getParameterApiModel();
        parameter.FetchParams = {
            FetchItems: true,
            FetchTotalCount: fetchingAllData,
            FetchLightWeightObjects: fetchingAllData,
        };
        return this.checklistService.getCheckListTemplatesListData(parameter).then((response) => {
            this.ListData.appendData(response.Items);

            if (fetchingAllData) {
                this.ListData.SetTotalItemsCount(response.TotalCount);

                const lightWeightObjectCollection = response.LightWeightObjectsForLocalSearch;
                if (lightWeightObjectCollection) {
                    this.ListData.raiseLightWeightObjectCollectionChanged(lightWeightObjectCollection);
                }
            }
        });
    }

    private getParameterApiModel() {
        const result: IItemsListParameterBase = {
            SelectedSort: {
                ColumnName: this.ListData.Sort.Column,
                SortDirection: this.ListData.Sort.Reverse,
            },
            Names: [],
            Ids: [],
            FilterType: this.ListData.FilterType,
        };

        Object.assign(result, this.ListData.getOffsetParams());

        this.ListData.mergeLocalSearchV2Parameter(result);

        return result;
    }
}
